// extracted by mini-css-extract-plugin
export var discard = "_3y-3";
export var muiTooltipTooltip = "_3y-5";
export var notificationBar = "_3y-2";
export var saveButtonHoverSlotWrapper = "_3y-4";
export var show = "_3y-1";
export var spacer = "_3y-0";